export default __webpack_public_path__ + "static/media/tangent.316baef1.png";